import { QuestionDetails } from "../../api";
import i18next from "../../i18n/i18n";
import appInfoDefaults from "../../../resources/app_info.json";

export interface AttachedFileLoadingMeta {
    message: string;
    fileNames: string[];
}

const getLocaleResourceKey = (): "commonEn" | "commonJa" => {
    const locale = (i18next.resolvedLanguage ?? i18next.language ?? "").toLowerCase();
    return locale.startsWith("ja") ? "commonJa" : "commonEn";
};

const getFallbackAnswerLabel = (key: "attachedFileProcessing" | "responseProcessing"): string => {
    const localeResourceKey = getLocaleResourceKey();
    const label = appInfoDefaults?.[localeResourceKey]?.answer?.[key];
    return typeof label === "string" ? label : "";
};

const getAttachedFileNames = (filesAttached?: QuestionDetails["filesAttached"]): string[] => {
    if (!Array.isArray(filesAttached) || filesAttached.length === 0) {
        return [];
    }

    return filesAttached.map(attachment => (attachment?.file?.name ?? "").trim()).filter((fileName): fileName is string => fileName.length > 0);
};

export const getAttachedFileLoadingMeta = (filesAttached?: QuestionDetails["filesAttached"]): AttachedFileLoadingMeta => {
    const hasAttachments = Array.isArray(filesAttached) && filesAttached.length > 0;
    const attachedFileNames = hasAttachments ? getAttachedFileNames(filesAttached) : [];
    const translationKey = hasAttachments ? "answer.attachedFileProcessing" : "answer.responseProcessing";
    const fallbackKey = hasAttachments ? "attachedFileProcessing" : "responseProcessing";
    const message = i18next.t(translationKey);

    return {
        message: message === translationKey ? getFallbackAnswerLabel(fallbackKey) : message,
        fileNames: attachedFileNames
    };
};
